import { render, staticRenderFns } from "./MarginKpiHealingCardTitle.vue?vue&type=template&id=845c5e0c&"
import script from "./MarginKpiHealingCardTitle.vue?vue&type=script&lang=js&"
export * from "./MarginKpiHealingCardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports